import React from 'react';
import './SourceSelector.css';

const SourceSelector = ({ onSourceSelect }) => {
  const sources = [
    { id: 'all', name: '', color: 'transparent', label: 'All of\nIntellyx' },  // No background, no text
    { id: 'JB', name: '', color: '#e74c3c', label: 'Jason\nBloomberg' },  // Complementary Red
    { id: 'JE', name: '', color: '#1E5BA8', label: 'Jason\nEnglish' },  // Intellyx Blue
    { id: 'EN', name: '', color: '#2ecc71', label: 'Eric\nNewcomer' }   // Complementary Green
  ];

  const getBackgroundImage = (sourceId) => {
    const imageMap = {
      all: `${process.env.PUBLIC_URL}/images/intellyx-logo.png`,
      JE: `${process.env.PUBLIC_URL}/images/JE.jpg`,
      JB: `${process.env.PUBLIC_URL}/images/JB.jpg`,
      EN: `${process.env.PUBLIC_URL}/images/EN.jpg`
    };
    return imageMap[sourceId] || '';
  };

  return (
    <div className="source-selector">
      <h4>Choose an analyst to start your AI chat:</h4>
      <div className="source-circles">
        {sources.map((source) => (
          <div key={source.id} className="source-container"  onClick={() => onSourceSelect(source.id)}>
            <div
              className={`source-circle author-${source.id}`}
              style={{ 
                backgroundColor: source.color,
                backgroundImage: `url(${getBackgroundImage(source.id)})`,
                backgroundSize: 'cover',
                backgroundPosition: source.id === 'all' ? 'left center' : 'center',
                backgroundRepeat: 'no-repeat'
              }}             
            >
              {source.name}
            </div>
            <div className="source-label-text">{source.label}</div>
          </div>
        ))}
      </div>    
    </div>
  );
};

export default SourceSelector; 